<template>
    <v-card
        min-height="200"
        color="grey lighten-5"
        :hover="currSubStepInDataset === 1"
    >
        <v-card-title>
            <!-- list display START -->
            <template v-if="currSubStepInDataset === 1">
                <div
                    class="headline primary--text"
                    :class="{ 'grey--text': !dataset.enabled }"
                >
                    <v-icon color="primary">
                        {{ $appConfig.dataset.icon }}
                    </v-icon>
                    {{ dataset.name }}
                </div>
                <v-col cols="12">
                    <div class="grey--text caption">
                        Updated: {{ dataset.updated_at }}
                    </div>
                </v-col>
                <v-col cols="12">
                    <div class="subheading">
                        {{ dataset.description }}
                    </div>
                </v-col>

                <template v-if="!dataset.labels.length">
                    <v-chip label outlined>
                        No label
                    </v-chip>
                </template>
                <template v-else v-for="label in dataset.labels">
                    <v-chip label outlined>
                        {{ label.name }}
                    </v-chip>
                </template>
            </template>
            <!-- list display END -->

            <!-- selected dataset display START -->
            <template v-else>
                <div
                    class="headline primary--text"
                    :class="{ 'grey--text': !trigger.source.enabled }"
                >
                    <v-icon color="primary">
                        {{ $appConfig.dataset.icon }}
                    </v-icon>
                    {{ trigger.source.name }}
                </div>
                <v-col cols="12">
                    <div class="grey--text caption">
                        Updated: {{ trigger.source.updated_at }}
                    </div>
                </v-col>
                <v-col cols="12">
                    <div class="subheading">
                        {{ trigger.source.description }}
                    </div>
                </v-col>

                <template v-for="label in trigger.source.labels">
                    <v-chip label outlined>
                        {{ label.name }}
                    </v-chip>
                </template>
                <template v-if="!trigger.source.labels.length">
                    <v-chip label outlined>
                        No label
                    </v-chip>
                </template>
            </template>
        </v-card-title>
        <v-divider v-if="currSubStepInDataset === 2" />
        <v-card-text v-if="currSubStepInDataset === 2">
            <template>
                <span>Choose a type of request</span>
                <v-select
                    v-model="requestSelect"
                    :items="requests"
                    label="request"
                    single-line
                    item-text="text"
                    item-value="hint"
                    return-object
                    @input="updateTrigger"
                />
                <v-row>
                    <v-col cols="6">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    slot="activator"
                                    block
                                    :color="
                                        currFetch === 'PRE' ? 'primary' : ''
                                    "
                                    v-on="on"
                                    @click.native="buttonClicked('PRE')"
                                >
                                    PRE
                                </v-btn>
                            </template>
                            <span>
                                The function will be called BEFORE the request
                                you chose (Read, Update, Delete) is performed
                            </span>
                        </v-tooltip>
                    </v-col>
                    <v-col cols="6">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    slot="activator"
                                    block
                                    :color="
                                        currFetch === 'POST' ? 'primary' : ''
                                    "
                                    @click.native="buttonClicked('POST')"
                                    v-on="on"
                                >
                                    POST
                                </v-btn>
                            </template>
                            <span>
                                The function will be called AFTER the request
                                you chose (Read, Update, Delete) is
                                performed</span
                            >
                        </v-tooltip>
                    </v-col>
                </v-row>
            </template>
        </v-card-text>
        <!-- selected dataset display END -->
    </v-card>
</template>

<script>
export default {
    props: {
        dataset: {},
        index: Number,
        isSelected: Boolean,
        currSubStep: Number,
        currFetch: {
            type: String,
            default: ""
        },
        currRequest: {
            type: String,
            default: ""
        },
        trigger: {}
    },
    data() {
        return {
            clicked: Boolean,
            isNew: Boolean,
            currSubStepInDataset: this.currSubStep,
            mytrigger: {},
            requests: [
                { text: "Read", value: "READ" },
                { text: "Update", value: "UPDATE" },
                { text: "Delete", value: "DELETE" }
            ],
            requestSelect: {}
        };
    },
    watch: {
        currSubStep: function() {
            this.currSubStepInDataset = this.currSubStep;
        },
        trigger: function() {
            this.mytrigger = this.trigger;
        }
    },
    mounted: function() {
        if (typeof this.trigger.request_choice !== "undefined") {
            this.requestSelect = this.requests.find(
                x => x.value === this.trigger.request_choice
            );
        }
    },
    methods: {
        buttonClicked(choice) {
            this.$emit("buttonClicked", choice);
        },
        updateTrigger() {
            this.trigger.request_choice = this.requestSelect.value;
            this.$emit("sendTriggerState", this.trigger);
        }
    }
};
</script>
